module.exports = __webpack_public_path__ + "img/CATEGORY ICON-19.bae38c14.png";